import { ApiState } from "infrastructure/api";
import type { RootState } from "infrastructure/store";

export const selectIsMerchantsMethodsPivotLoading = (state: RootState) =>
    state.pivots.merchantsMethods.loadingState === ApiState.Pending;

export const selectMerchantsMethodsPivotSlice = (state: RootState) =>
    state.pivots.merchantsMethods.slice;
